jQuery(document).ready(function($) {

    var action_url = '/cms/wp-admin/admin-ajax.php?action=filter_dates';

    function append_result(data) {

        if (data == "") {
            data = '<div class="no_dates_message"><p>Leider gibt es für dieses Seminarthema oder diesen Ort aktuell keine Präsenztermine. Wenn Sie an diesem Seminarthema interessiert sind, biete ich auch die Möglichkeit für ein <a href="/seminare/inhouse-seminare/">Inhouse-Seminar</a> an.</p></div>';
        }

        $('.module-layotternextdates .next-dates-wrapper').append(data).hide().fadeIn(200, function() {

            $('.loader').fadeOut(100, function() {
                $(this).remove();
            });

            if ($('.date').hasClass('last-item')) {
                $('#load-more').hide();
            }

            $('button.disabled').removeClass('disabled').attr('disabled', false);

        });

        $('[data-toggle="popover"]').popover({html: true, trigger: 'focus'});

    }

    function set_active_state(el) {
        $('.module-layotterfilterbar').find('.active').removeClass('active');
        el.addClass('active');
    }

    function set_filter_info(filter) {
        $('.js-current-filter').text(filter);
    }

    function appendSpinner() {
        $('.module-layotternextdates .next-dates-wrapper').empty().parent().append('<div class="loader fa-3x"><i class="fas fa-spinner fa-pulse"></i></div>');
        $('#load-more').hide();
    }


    //filter reset
    $('.js-delete-filter').click(function() {
        $('.module-layotterfilterbar .active').removeClass('active');

        appendSpinner();

        $.post(action_url, {reset: true}, function(data) {
            append_result(data);
            $('.filter-info').removeClass('show');
            $('#load-more').show();
        });
    });

    //filter locations
    $('#locations li').click(function() {

        var location = $(this).text();

        set_active_state($(this));
        set_filter_info(location);

        appendSpinner();

        $.post(action_url, {location: location}, function(data) {
            $(this).addClass('active');
            $('.filter-info').addClass('show');
            append_result(data);
        });

    });

    //filter topics
    $('#topics li').click(function() {

        var topic = $(this).text();

        set_active_state($(this));
        set_filter_info(topic);

        appendSpinner();

        $.post(action_url, {topic: topic}, function(data) {
            $(this).addClass('active');
            $('.filter-info').addClass('show');
            append_result(data);
        });

    });

    //pre-filtering items on page load
    if ($('#topics .active').length) {

        var topic = $('#topics .active').text();
        set_filter_info(topic);

        appendSpinner();

        $.post(action_url, {topic: topic}, function(data) {
            $(this).addClass('active');
            $('.filter-info').addClass('show');
            append_result(data);
        });
    }

    //load more button
    $('#load-more').click(function() {
        var lastDate = $('.module-layotternextdates .date').last().data('date');

        $(this).addClass('disabled').attr('disabled', true);

        $.post(action_url, {lastDate: lastDate}, function(data) {
            append_result(data);
        });

    });

    //default on page load, without prefiltering items

    if ($('.module-layotternextdates .next-dates-wrapper').length && $('#topics .active').length == 0) {

        appendSpinner();

        //load only dates with same post id

        if ($('.module-layotternextdates .next-dates-wrapper').data('post-id')) {

            var post_id = $('.module-layotternextdates .next-dates-wrapper').data('post-id');

            $.post(action_url, {post_id: post_id}, function(data) {
                append_result(data);
                $('.filter-info').removeClass('show');
                $('.next-dates-wrapper').trigger('contentchanged');
            });

        } else if ($('#topics .active').length == 0) {

            //load all dates

            $.post(action_url, {reset: true}, function(data) {
                append_result(data);
                $('.filter-info').removeClass('show');
                $('#load-more').show();
                $('.next-dates-wrapper').trigger('contentchanged');
            });

        }
    }

});
